// Lightweight analytics helper for the people-listing directory.
// Fans events out to GA4 (window.gtag) and Azure App Insights
// (window.appInsights). Both globals are loaded site-wide via Razor
// partials; if either is missing we silently drop the event.

function commonDims() {
  return {
    directory_context: window.testingDept || 'root',
    page_path: window.location.pathname
  };
}

export function track(name, props = {}) {
  const payload = { ...commonDims(), ...props };

  if (typeof window.gtag === 'function') {
    window.gtag('event', name, payload);
  }

  if (window.appInsights && typeof window.appInsights.trackEvent === 'function') {
    window.appInsights.trackEvent({
      name: 'directory_' + name,
      properties: payload
    });
  }
}

let searchTimer = null;

export function trackSearch(searchTerm) {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    track('search_query', { search_term: searchTerm || null });
    searchTimer = null;
  }, 500);
}
